/*
 *
 * Date: 2025
 * Description: View modal context for displaying alerts in the application
 * Author: Philippe Leroux @SKITSC
 *
 */


//Components
import { createContext , useState , useContext  } from "react";

//Interfaces
import { i_sub_main_props, i_view_modal_props } from "../interfaces/utility.interface";
import { i_user } from "../interfaces/user.interface";

//Components
import ViewModal from "../components/modal/view.modal";
import { i_user_orders } from "../interfaces/items.interface";

const ViewModalContext = createContext<{ showPartModal: (a: string) => void , showUserModal: (a : i_user_orders) => void, closeModal : () => void }>({ showPartModal: () => {} , showUserModal: () => {}, closeModal : () => {} });

export const ShowModalProvider = (props : i_sub_main_props) => {
    const [ modal , setModal ] = useState<i_view_modal_props | null>(null);
    const [ pathing ] = useState<string>(props.uploadPath + props.path + '/uploads/parts/')
    const showPartModal = (item : string) => {
        const viewModalProps : i_view_modal_props = {
            selected :  item,
            setSelected : () => setModal(null),
            path : pathing,
            type : 'part'
        }
        setModal(viewModalProps);
    };
   const showUserModal = (user : i_user_orders) => {
        const viewModalProps : i_view_modal_props = {
            selected : user,
            setSelected : () => setModal(null),
            path : pathing,
            type : 'user'
        }
        setModal(viewModalProps);
  };

  const closeModal = () => {
        setModal(null)
  };

  return (
    <ViewModalContext.Provider value={{ showPartModal , showUserModal, closeModal }}>
        {modal && <ViewModal {...modal} />}
        {props.children}
    </ViewModalContext.Provider>
  );
};

export const useViewModal = () => useContext(ViewModalContext);